import { nvFetch } from '../helpers/nvFetch';
import { completelyFetchResource } from '../helpers/resources';
import {
  ApiForwardingRule,
  ApiForwardingRuleCreate,
} from '../types/ForwardingRule';

export const getForwardingRules = async (
  customerId: string,
  endpointId: string,
) => {
  const fetchRes = await completelyFetchResource<ApiForwardingRule>(
    `endpoints/${endpointId}/forwardingrules`,
    '',
    { pageSize: 200 },
    customerId,
  );
  return fetchRes;
};

export const saveForwardingRule = async (
  customerId: string,
  endpointId: string,
  forwardingRule: ApiForwardingRule,
) => {
  const requestUrl = `customers/${customerId}/endpoints/${endpointId}/forwardingrules/${forwardingRule.id}`;
  const fetchRes = await nvFetch(requestUrl, {
    method: 'PUT',
    body: JSON.stringify(forwardingRule),
  });

  return (await fetchRes.json()) as ApiForwardingRule;
};

export const removeForwardingRule = async (
  customerId: string,
  endpointId: string,
  forwardingRuleId: string,
) => {
  const requestUrl = `customers/${customerId}/endpoints/${endpointId}/forwardingrules/${forwardingRuleId}`;
  await nvFetch(requestUrl, { method: 'DELETE' });
};

export const createForwardingRule = async (
  customerId: string,
  endpointId: string,
  forwardingRule: ApiForwardingRuleCreate,
) => {
  const requesturl = `customers/${customerId}/endpoints/${endpointId}/forwardingrules`;
  const fetchRes = await nvFetch(requesturl, {
    method: 'POST',
    body: JSON.stringify(forwardingRule),
  });

  return (await fetchRes.json()) as ApiForwardingRule;
};
